import React from "react"
import PropTypes from "prop-types"
import {ButtonGroup} from "react-bootstrap"

const FormButtons = (props) => {
		const {name, currentValue, options, onInputChange, className = "buttons-justify"} = props;

		const buttons = [];
		for (let i in options) {
			if (options.hasOwnProperty(i)) {
				const option = options[i];

				let isActive = false;
				if (currentValue && currentValue.constructor === Array) {
					isActive = currentValue.indexOf(option.value) > -1
				} else {
					isActive = currentValue === option.value
				}

				buttons.push(<label key={i} className={"btn " + (isActive ? "btn-info" : "btn-default")} title={option.title}>
					{option.label}
					<input type="checkbox" name={name} value={option.value} onChange={(e) => {
						onInputChange(e, true)
					}} checked={isActive}/>
				</label>)
			}
		}

		return <ButtonGroup data-toggle="buttons" className={className}>
			{buttons}
		</ButtonGroup>
};

FormButtons.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	currentValue: PropTypes.any,
	onInputChange: PropTypes.func.isRequired
};

export default FormButtons


// WEBPACK FOOTER //
// ./src/components/form/FormButtons.js